import React from 'react';
const bonuses = [{
  name: 'CLASE LISTA EN 10 MIN',
  desc: 'Plantillas + checklists para armar tu clase sin improvisar.',
  price: '$8.000'
}, {
  name: 'BANCO DE VARIANTES INFINITAS',
  desc: '120 variantes en 3 niveles para adaptar cualquier ejercicio.',
  price: '$10.000'
}, {
  name: 'SIN FILAS, SIN CAOS',
  desc: 'Layouts de estaciones, códigos de voz y protocolo del primer día.',
  price: '$9.000'
}, {
  name: 'KIT LLUVIA & ESPACIO CHICO',
  desc: '40 sesiones por nivel para cuando no tenés cancha.',
  price: '$9.000'
}, {
  name: 'WHATSAPP PROFE',
  desc: '60 mensajes listos para padres: lesiones, conducta, post-partido.',
  price: '$8.000'
}, {
  name: 'EVALUACIÓN RÁPIDA',
  desc: 'Tests técnicos, planillas e informes para padres en 15 min.',
  price: '$9.000'
}];
export function BonusSection() {
  return <section className="w-full bg-black py-12 sm:py-16 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-8" data-id="element-3">
          <h2 className="text-2xl sm:text-4xl font-black text-white mb-2" data-id="element-4">
            Más los <span className="text-[#00C853]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base" data-id="element-6">
            Incluidos sin costo extra en todas las opciones
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-7">
          {bonuses.map((bonus, i) => <div key={i} className="flex items-start gap-3 sm:gap-4 bg-[#001a0d] border border-[#00C853]/40 rounded-xl p-3 sm:p-4" data-id="element-8">
              <div className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-[#00C853]/10 border border-[#00C853]/30 flex items-center justify-center" data-id="element-9">
                <span className="text-[#00C853] font-black text-sm sm:text-base" data-id="element-10">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-11">
                <h3 className="text-white font-black text-sm sm:text-base leading-tight" data-id="element-12">
                  🎁 {bonus.name}
                </h3>
                <p className="text-gray-400 text-xs sm:text-sm mt-0.5 leading-snug" data-id="element-13">
                  {bonus.desc}
                </p>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2" data-id="element-14">
                <span className="text-gray-500 line-through text-xs sm:text-sm" data-id="element-15">
                  {bonus.price}
                </span>
                <span className="bg-[#00C853] text-black font-black text-[10px] sm:text-xs px-2 py-0.5 rounded-full" data-id="element-16">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="border border-[#00C853]/40 rounded-xl p-4 sm:p-5 text-center bg-[#000d08]" data-id="element-17">
          <p className="text-[#00C853] text-xs sm:text-sm font-semibold uppercase tracking-widest mb-1" data-id="element-18">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-19">
            <span className="text-gray-400 line-through text-base sm:text-lg" data-id="element-20">
              $53.000
            </span>
            <span className="text-[#00C853] text-lg sm:text-2xl font-black" data-id="element-21">
              🎁 GRATIS con tu MegaPack
            </span>
          </div>
        </div>
      </div>
    </section>;
}